import { IReconciliationInitialValues } from '../../types';

export const INITIAL_VALUES: IReconciliationInitialValues = {
  organization: 0,
  current_account: '',
  reconciliation_date: '',
  total_debt: undefined,
  due_debt: undefined,
  currency: '',
};
